import Spinner from "../spinner"
import "./index.css"

const PageLoader = ({ text, size, block, dark }) => {
    return (
        <div className={`${block ? "pageload-block" : "pageload-main"} ${dark ? "pageload-dark" : ""}`}>
            <Spinner text={text || "Loading..."} size={size} textStyle={{ color: dark ? "white" : "#333" }} />
        </div>
    )
}

export default PageLoader